"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAppOrigin = exports.EAppType = void 0;
var EAppType;
(function (EAppType) {
    EAppType["DeltaClass1"] = "deltaclass1";
    EAppType["DeltaClass2"] = "deltaclass2";
    EAppType["Educador"] = "educador";
    EAppType["Push"] = "push";
    EAppType["AlunoOnline"] = "aluno";
    EAppType["DeltaSGE"] = "sge";
})(EAppType = exports.EAppType || (exports.EAppType = {}));
//TODO: implementar no token
var EAppOrigin;
(function (EAppOrigin) {
    EAppOrigin["DeltaClass2"] = "deltaclass2";
    EAppOrigin["DeltaClass1"] = "deltaclass1";
    EAppOrigin["Educador"] = "educador";
    EAppOrigin["OnLine2"] = "online2";
    EAppOrigin["Conversor"] = "conversor";
    EAppOrigin["Exportador2"] = "exportador2";
    EAppOrigin["Sge2"] = "sge2";
    EAppOrigin["Catraca"] = "catraca";
    EAppOrigin["Bib"] = "bib";
    EAppOrigin["Pettigrew"] = "pettigrew";
    EAppOrigin["Voldemort"] = "voldemort";
    EAppOrigin["Relatorio"] = "relatorio";
    EAppOrigin["Sge2Online"] = "sge2-online";
    EAppOrigin["Autenticador"] = "auth";
    EAppOrigin["Push"] = "push";
})(EAppOrigin = exports.EAppOrigin || (exports.EAppOrigin = {}));
